/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateDisclosureAcceptanceRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/update_disclosure_acceptance.pb'
import {UpdateDisclosureAcceptanceResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/update_disclosure_acceptance.pb'


export const updateDisclosureAcceptance = (request: UpdateDisclosureAcceptanceRequest, options?: CashRequestOptions) => post<UpdateDisclosureAcceptanceRequest, UpdateDisclosureAcceptanceResponse>("/cash-app/community/update-disclosure-acceptance", request, {...options, rejectOnError: true })